import AIAssistants from '../../AIAssistants';

function AIAssistantsTab() {
  return <AIAssistants />;
}

export default AIAssistantsTab;
